import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 500 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Tan Yong He",
  title: "Hi all, I'm Yong He",
  subTitle: emoji(
    "A passionate Full-Stack Software Engineer 🚀 with strong problem-solving, critical thinking, and communication skills. Motivated by a desire to tackle real-world challenges through technology and craft meaningful user experiences."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1xOtAuGkQ_8oyLMvyD1RinL-D8ER4oHBR/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/tanyonghe",
  linkedin: "https://www.linkedin.com/in/tanyonghe/",
  gmail: "tanyonghe@u.nus.edu",
  //gitlab: "https://gitlab.com/saadpasta",
  facebook: "https://www.facebook.com/tanyonghe/",
  instagram: "https://www.instagram.com/tan_yong_he/",
  dev: "https://dev.to/tanyonghe",
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "Passionate Full-Stack Engineer Always Ready to Tackle Any Tech Stack",
  skills: [
    emoji(
      "⚡ Building highly interactive, user-friendly Frontend/UI for both web and mobile applications"
    ),
    emoji(
      "⚡ Developing Progressive Web Applications (PWA) with seamless experiences, both in traditional and SPA architectures"
    ),
    emoji(
      "⚡ Crafting robust backend systems using modern technologies and APIs"
    ),
    emoji(
      "⚡ Implementing CI/CD pipelines for automated and efficient deployments"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    // Programming Languages
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fas fa-file-code"
    },
    {
      skillName: "Bash",
      fontAwesomeClassname: "fas fa-terminal"
    },
    // Front-End & Web
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "React.js",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "AngularJS",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "NPM",
      fontAwesomeClassname: "fab fa-npm"
    },
    // Back-End
    {
      skillName: "Spring Boot",
      fontAwesomeClassname: "fas fa-cogs"
    },
    // Databases & Data Tools
    {
      skillName: "Apache Cassandra",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "fas fa-database"
    },
    // Cloud Technologies
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    // {
    //   schoolName: "Harvard University",
    //   logo: require("./assets/images/harvardLogo.png"),
    //   subHeader: "Master of Science in Computer Science",
    //   duration: "September 2017 - April 2019",
    //   desc: "Participated in the research of XXX and published 3 papers.",
    //   descBullets: [
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
    //   ]
    // },
    {
      schoolName: "National University of Singapore (NUS)",
      logo: require("./assets/images/organizations/nus_logo.png"),
      subHeader: "Bachelor of Computing in Computer Science (Honours)",
      duration: "August 2016 - July 2020",
      desc: "CS Focus Areas:",
      descBullets: ["Computer Security", "Networking and Distributed Systems"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer, Associate",
      company: "J.P. Morgan Singapore",
      companylogo: require("./assets/images/organizations/jpmc_logo.png"),
      date: "Sep 2021 – Present",
      desc: "At J.P. Morgan, I developed full-stack solutions for internal enterprise applications, driving efficiency, scalability, and user experience across multiple lines of business. On the frontend, I built high-performance, responsive Single Page Applications using React, TypeScript, and modern state management tools. On the backend, I designed microservices in Java, crafted scalable REST and GraphQL APIs, and implemented client-server communication protocols that supported cross-functional workflows."
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      role: "Cyber Engineer",
      company: "Defence Science and Technology Agency (DSTA)",
      companylogo: require("./assets/images/organizations/dsta_logo.jpeg"),
      date: "June 2020 – Sep 2021",
      desc: "At DSTA, I worked on securing mission-critical systems for MINDEF/SAF through a blend of cybersecurity engineering and data-driven automation. I conducted vulnerability assessments, performed penetration testing, and enforced secure design principles across enterprise systems. In parallel, I engineered scalable data pipelines and analytics tools to support cybersecurity insights at scale."
    },
    {
      role: "Malware Analyst Intern",
      company: "Centre for Strategic Infocomm Technologies (CSIT)",
      companylogo: require("./assets/images/organizations/csit_logo.png"),
      date: "May 2019 – Aug 2019",
      desc: "As a Malware Analyst Intern at CSIT, I developed a machine learning-based tool to detect and classify malware from Portable Executable (PE) files. Leveraging n-gram analysis on binary data, the tool achieved a high recall rate of 92%, effectively identifying malicious patterns while minimizing false negatives."
    },
    {
      role: "Data Analyst Intern",
      company: "ViSenze - AI for Visual Commerce",
      companylogo: require("./assets/images/organizations/visenze_logo.jpeg"),
      date: "May 2018 – Aug 2018",
      desc: "I monitored performance of visual search systems to analyze and generate insights. Identified opportunities and improved search performance by 21% from baseline."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: true, // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    // {
    //   image: require("./assets/images/saayaHealthLogo.webp"),
    //   projectName: "Saayahealth",
    //   projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "http://saayahealth.com/"
    //     }
    //     //  you can add extra buttons here.
    //   ]
    // },
    // {
    //   image: require("./assets/images/nextuLogo.webp"),
    //   projectName: "Nextu",
    //   projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "http://nextu.se/"
    //     }
    //   ]
    // }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Bird Box Challenge",
      subtitle:
        "Won NUS Hack & Roll 2019. Integrated gamification into physiotherapy to enhance patient engagement and enjoyment.",
      image: require("./assets/images/achievements/bird_box_challenge.png"),
      imageAlt: "Bird Box Challenge",
      footerLink: [
        {
          name: "Winner",
          url: "https://devpost.com/software/bird-box-challenge"
        }
      ]
    },
    {
      title: "Get Into My Head",
      subtitle:
        "1st runner-up in The Good Idea: A Hackathon for Good. With VR technology, we can be one step closer to better understanding what people suffering from depression feels.",
      image: require("./assets/images/achievements/get_into_my_head.png"),
      imageAlt: "Get Into My Head",
      footerLink: [
        {
          name: "Winner",
          url: "https://devpost.com/software/get-into-my-head"
        }
      ]
    },
    {
      title: "WITS Robot",
      subtitle:
        "Featured in NUS Makerthon 2019. Built a physical robot dog that interacts with children suffering from cerebral palsy to promote fun exercises.",
      image: require("./assets/images/achievements/wits_robot.jpg"),
      imageAlt: "WITS Robot",
      footerLink: [
        {
          name: "Featured",
          url: "https://www.facebook.com/nus.singapore/photos/a.446149828539/10156896944568540/?type=3&theater"
        }
      ]
    },
    {
      title: "Bucketlist",
      subtitle:
        "Audience's Choice in NOC Pitch Night 2019. Developed a visual-first, data-driven travel platform connecting hand-picked businesses to tourists.",
      image: require("./assets/images/achievements/bucketlist.png"),
      imageAlt: "Bucketlist",
      footerLink: [
        {
          name: "Audience's Choice",
          url: "https://www.youtube.com/watch?v=JC0-eH8XbdE"
        }
      ]
    },
    {
      title: "AWS Certified Cloud Practitioner",
      subtitle:
        "The AWS Certified Cloud Practitioner validates foundational, high-level understanding of AWS Cloud, services, and terminology.",
      image: require("./assets/images/certifications/aws_ccp.png"),
      imageAlt: "AWS Certified Cloud Practitioner",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/308de727-dd1d-44a1-bb6f-86f52e3d1c68"
        }
      ]
    },
    /*{
      title: "AWS Certified Solutions Architect - Associate",
      subtitle:
        "The AWS Certified Solutions Architect - Associate exam validates a candidate's ability to design and implement solutions on AWS using various services and technologies, adhering to the AWS Well-Architected Framework.",
      image: require("./assets/images/certifications/aws_csaa.png"),
      imageAlt: "AWS Certified Solutions Architect - Associate",
      footerLink: [
        {
          name: "Certification",
          url: ""
        }
      ]
    },*/
    {
      title: "Azure AI Fundamentals",
      subtitle:
        "Demonstrate fundamental AI concepts related to the development of software and services of Microsoft Azure to create AI solutions.",
      image: require("./assets/images/certifications/azure_ai_fundamentals.png"),
      imageAlt: "Azure AI Fundamentals",
      footerLink: [
        {
          name: "Certification",
          url: "https://learn.microsoft.com/api/credentials/share/en-us/tanyonghe/994D477C774746BE?sharingId=161170FA7CD215E1"
        }
      ]
    },
    {
      title: "Azure Data Fundamentals",
      subtitle:
        "Demonstrate foundational knowledge of core data concepts related to Microsoft Azure data services.",
      image: require("./assets/images/certifications/azure_data_fundamentals.png"),
      imageAlt: "Azure Data Fundamentals",
      footerLink: [
        {
          name: "Certification",
          url: "https://learn.microsoft.com/api/credentials/share/en-us/tanyonghe/2244798E94F6313F?sharingId=161170FA7CD215E1"
        }
      ]
    },
    {
      title: "Azure Fundamentals",
      subtitle:
        "Demonstrate foundational knowledge of cloud concepts, core Azure services, plus Azure management and governance features and tools.",
      image: require("./assets/images/certifications/azure_fundamentals.png"),
      imageAlt: "Azure Fundamentals",
      footerLink: [
        {
          name: "Certification",
          url: "https://learn.microsoft.com/api/credentials/share/en-us/tanyonghe/CF5EE1147AB57484?sharingId=161170FA7CD215E1"
        }
      ]
    },
    {
      title: "Certified Kubernetes Application Developer (CKAD)",
      subtitle:
        "The Certified Kubernetes Application Developer (CKAD) exam certifies that candidates can design, build and deploy cloud-native applications for Kubernetes.",
      image: require("./assets/images/certifications/ckad.png"),
      imageAlt: "Certified Kubernetes Application Developer (CKAD)",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/8fc14807-3b3f-42d7-a984-bcb3cf5ed809"
        }
      ]
    },
    {
      title: "Certified ScrumMaster® (CSM®)",
      subtitle:
        "A globally recognized certification by Scrum Alliance that validates a professional's understanding of the Scrum framework and their ability to effectively guide Scrum teams.",
      image: require("./assets/images/certifications/scrum_alliance_csm.png"),
      imageAlt: "Certified ScrumMaster® (CSM®)",
      footerLink: [
        {
          name: "Certification",
          url: "https://bcert.me/seukxmvgj"
        }
      ]
    },
    {
      title: "Google Cloud Digital Leader",
      subtitle:
        "The Google Cloud Digital Leader certification exam validates foundational knowledge of cloud computing principles and Google Cloud products.",
      image: require("./assets/images/certifications/google_cdl.png"),
      imageAlt: "Google Cloud Digital Leader",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/32afb77b-2be3-4a89-8bff-68b2337a3480/public_url"
        }
      ]
    },
    {
      title: "Google Associate Cloud Engineer",
      subtitle:
        "The Google Cloud Certified Associate Cloud Engineer exam validates fundamental skills in deploying, maintaining, and monitoring cloud projects on Google Cloud Platform (GCP).",
      image: require("./assets/images/certifications/google_ace.png"),
      imageAlt: "Google Associate Cloud Engineer",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/8cb0eb74-91b3-4fa5-881b-9c0926bee9f7/public_url"
        }
      ]
    },
    {
      title: "Nokia Bell Labs 5G Certified Associate",
      subtitle:
        "The Nokia Bell Labs 5G Certified Associate exam validates foundational knowledge in 5G technologies and industry trends.",
      image: require("./assets/images/certifications/nokia_5g_certified_associate.png"),
      imageAlt: "Nokia Bell Labs 5G Certified Associate",
      footerLink: [
        {
          name: "Certification",
          url: "https://learningstore.nokia.com/srv1/openbadge/award/5f2bc6fad1819d571061c1a125763b24/html"
        }
      ]
    },
    {
      title: "Offensive Security Certified Professional (OSCP)",
      subtitle:
        "The OffSec Certified Professional (OSCP+ & OSCP) certifications, are designed for cybersecurity professionals to validate practical, hands-on skills in ethical hacking and penetration testing.",
      image: require("./assets/images/certifications/offsec_oscp.png"),
      imageAlt: "Offensive Security Certified Professional (OSCP)",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credential.net/411f752b-6732-4b81-93ef-d4bc189233a2"
        }
      ]
    },
    {
      title: "Professional Scrum Master™ I (PSM I)",
      subtitle:
        "The Professional Scrum Master™ I (PSM I) certification from Scrum.org validates a professional's fundamental understanding of the Scrum framework, its values, and the Scrum Master's responsibilities.",
      image: require("./assets/images/certifications/scrum_org_psm_i.png"),
      imageAlt: "Professional Scrum Master™ I (PSM I)",
      footerLink: [
        {
          name: "Certification",
          url: ""
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: false, // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://dev.to/tanyonghe/ditching-postman-why-and-how-i-transitioned-to-bruno-535e",
      title: "🐶 Ditching Postman: Why and How I Transitioned to Bruno",
      description:
        "🛠️ As a developer who regularly works with APIs, Postman has been the go-to choice for testing, documenting, and sharing across teams. However, over time, I began to feel the bloat. Postman became increasingly heavy, slow to start, and frustrating to use in version-controlled environments. That's when I discovered Bruno: a lightweight, open-source API client aiming to take on Postman's heavyweight legacy."
    },
    {
      url: "https://dev.to/tanyonghe/beware-the-evil-twin-exploring-wi-fi-impersonation-attacks-4chd",
      title: "😈 Beware the Evil Twin: Exploring Wi-Fi Impersonation Attacks",
      description:
        '🚨 Ever connected to "Free Airport Wi-Fi" without thinking twice? You might\'ve walked straight into an Evil Twin attack — a Wi-Fi impersonation trick used to steal credentials, snoop on traffic, or silently proxy your connection.'
    },
    {
      url: "https://dev.to/tanyonghe/redis-geohashing-storing-and-querying-location-data-with-ease-1gf4",
      title:
        "🌍 Redis Geohashing: Storing and Querying Location Data with Ease",
      description:
        "🛢️ Redis isn't just a blazing-fast in-memory data store — it also comes packed with geospatial capabilities that are incredibly handy when working with location-based applications. At the core of this is geohashing."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  //number: "+65-00000000",
  email_address: "tanyonghe@u.nus.edu"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
